"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class TransactionApi extends runtime.BaseAPI {
    /**
     * Gets the balance of the Event account for the given currency and group (including balance for any child groups, itemised). You can only request one currency at a time.
     */
    apiTransactionEventBalancePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Transaction/Event/Balance`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiBalanceRequestToJSON(requestParameters.apiBalanceRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AccountBalanceResponseIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Gets the balance of the Event account for the given currency and group (including balance for any child groups, itemised). You can only request one currency at a time.
     */
    apiTransactionEventBalancePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTransactionEventBalancePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Confirms a ticket transaction
     */
    apiTransactionEventConfirmPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Transaction/Event/Confirm`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiTransactionRequestToJSON(requestParameters.apiTransactionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Confirms a ticket transaction
     */
    apiTransactionEventConfirmPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTransactionEventConfirmPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Requests one or more payouts from the event account for the group(s) specified
     */
    apiTransactionEventPayoutPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Transaction/Event/Payout`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiPayoutRequestToJSON(requestParameters.apiPayoutRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ITransactionIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Requests one or more payouts from the event account for the group(s) specified
     */
    apiTransactionEventPayoutPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTransactionEventPayoutPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Requests a ticket transaction
     */
    apiTransactionEventTicketPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Transaction/Event/Ticket`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiCreateTransactionRequestToJSON(requestParameters.apiCreateTransactionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ITransactionIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Requests a ticket transaction
     */
    apiTransactionEventTicketPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTransactionEventTicketPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets transactions for Event account for given currency and group (including balance for any child groups, rolled up into main group). You can only request one currency at a time. The \'From\' must be provided and the PointInTime works both as the Point In Time and as a \'To\'. You can only request a maximum of 40 days of transactions.
     */
    apiTransactionEventTransactionsPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Transaction/Event/Transactions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiTransactionsRequestToJSON(requestParameters.apiTransactionsRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TransactionsResponseIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Gets transactions for Event account for given currency and group (including balance for any child groups, rolled up into main group). You can only request one currency at a time. The \'From\' must be provided and the PointInTime works both as the Point In Time and as a \'To\'. You can only request a maximum of 40 days of transactions.
     */
    apiTransactionEventTransactionsPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTransactionEventTransactionsPostRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.TransactionApi = TransactionApi;
